module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-600italic.02c4833312d94b1b0866f073023a250e.woff";